export function openNewTabURL(url) {
    const elem = window.document.createElement("a");
    elem.target = "_blank";
    elem.href = url;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }